import { render, staticRenderFns } from "./cleaning-form.vue?vue&type=template&id=1a2cf984&"
import script from "./cleaning-form.vue?vue&type=script&lang=js&"
export * from "./cleaning-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports